import { render, staticRenderFns } from "./MoreCourseByJoseph.vue?vue&type=template&id=699c994a"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CourseByJoseph: require('/vercel/path0/components/CourseByJoseph.vue').default})
